module.exports = __webpack_public_path__ + "static/media/colleges-icon-1.d79fcca9.svg";